import { defineComponent as _defineComponent } from 'vue'
import { withDefaults } from "vue";

/**
 * Types
 */

type Props = {
  title: string;
  isDisabled?: boolean;
};

/**
 * Component
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpansionPanel',
  props: {
    title: null,
    isDisabled: { type: Boolean, default: false }
  },
  emits: ["click", "info-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: "click", title: string): void;
  (e: "info-click"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string, isDisabled: boolean };





const handleClick = () => {
  emit("click", props.title);
};

return { __sfc: true,props, emit, handleClick }
}

})